export default __webpack_public_path__ + "static/media/AirbnbCerealBold.f286ae85.woff";